export default __webpack_public_path__ + "static/media/icon_talk.736de98b.png";